import { jsxs as c, jsx as r } from "react/jsx-runtime";
import S from "clsx";
import { forwardRef as x, useRef as A } from "react";
const M = (o) => S(o), R = () => `${Math.random().toString(36)}00000000000000000`.slice(2, 7), a = "dds-radio-v0152", C = x(
  ({
    ariaDescribedby: o,
    className: t = "",
    defaultChecked: l = !1,
    disabled: e = !1,
    hiddenLabel: n = !1,
    id: d,
    inputProps: m = {},
    label: s = "Default label",
    labelNode: u,
    name: _,
    onChange: f,
    value: p,
    ...$
  }, h) => {
    const v = {
      [a]: !0,
      [t]: t.length > 0,
      [`${a}--disabled`]: e
    }, { current: N } = A(`${a}-${R()}`), i = d || N, g = p || s;
    return /* @__PURE__ */ c("label", { htmlFor: i, className: M(v), ...$, children: [
      /* @__PURE__ */ r(
        "input",
        {
          "aria-describedby": o,
          id: i,
          type: "radio",
          className: `${a}__input`,
          defaultChecked: l,
          disabled: e,
          name: _,
          value: g,
          "aria-label": n ? s : void 0,
          ref: h,
          ...m,
          onChange: e ? void 0 : f
        }
      ),
      /* @__PURE__ */ c("div", { className: `${a}__control`, children: [
        /* @__PURE__ */ r("div", { className: `${a}__inner` }),
        /* @__PURE__ */ r("div", { className: `${a}__hidden-touch-target` })
      ] }),
      !n && (u ?? /* @__PURE__ */ r("span", { className: `${a}__label`, children: s }))
    ] });
  }
);
export {
  C as Radio
};
//# sourceMappingURL=index.js.map
